<template>
  <div>
    <div class="border-bottom-color padding-bottom">
      <el-row :gutter="20">
        <el-col :span="7">
          <div>
            <el-statistic
              :precision="2"
              title="签约时长"
            >
              <template slot="formatter">
                <b>{{lessonOpenInfo.sign_duration}}天</b>
              </template>
            </el-statistic>
          </div>
        </el-col>
        <el-col :span="9">
          <div>
            <el-statistic title="申请季倒计时">
              <template slot="formatter">
                <b>{{bindInfo.enrol_school_str}}</b>
              </template>
            </el-statistic>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <el-statistic
              :precision="2"
              title="con/unconoffer"
            >
              <template slot="formatter">
                <b>{{lessonOpenInfo.con_offer_num}}/{{lessonOpenInfo.uncon_offer_num}}个</b>
              </template>
            </el-statistic>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="border-bottom-color padding-bottom">
      <div style="margin-top:10px;font-weight: 700">软背景分析(当前/参考值)</div>
      <div ref="echartsRef" style="width:100%;height:300px;margin: 0 auto;"></div>
      <div class="bg_all">
        <div class="bg_content">实习工作经历：{{user_profiles.work_experience}}/<span class="color_blue">{{user_profiles.work_experience_num}}</span></div>
        <div class="bg_content">学术项目：{{user_profiles.academic_projects}}/<span class="color_blue">{{user_profiles.academic_projects_num}}</span></div>
        <div class="bg_content">荣誉奖励：{{user_profiles.honorary_rewards}}/<span class="color_blue">{{user_profiles.honorary_rewards_num}}</span></div>
        <div class="bg_content">课外活动：{{user_profiles.extracurricular_activities}}/<span class="color_blue">{{user_profiles.extracurricular_activities_num}}</span></div>
        <div class="bg_content">语言：{{user_profiles.language_achievement_and_account_secrecy}}/<span class="color_blue">{{user_profiles.language_num}}</span></div>
        <div style="clear: both"></div>
      </div>
    </div>
    <div class="border-bottom-color padding-bottom">
      <div  style="margin-top:10px;font-weight: 700">服务流程:</div>
      <div>
        <el-steps direction="vertical">
          <el-step>
            <template slot="title">
              <span style="color: black">确认选校</span>
            </template>
            <template slot="description">
              <el-card class="box-card">
                <div class="text item item_flex" v-for="item in apply_direction_data">
                  <div class="el-div-with">{{item.name}}：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="item.calculate"></el-progress>
                </div>
                <div class="text item item_flex" v-if="apply_direction_data.length==0" style="color: red">
                  <div class="el-div-with">暂无数据</div>
                </div>
              </el-card>
            </template>
          </el-step>
          <el-step>
            <template slot="title">
              <span style="color: black">填写资料</span>
            </template>
            <template slot="description">
              <el-card class="box-card">
                <div class="text item item_flex">
                  <div class="el-div-with">个人信息：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="information.information_pl"></el-progress>
                </div>
                <div class="text item item_flex">
                  <div class="el-div-with">cv：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="information.information_cv"></el-progress>
                </div>
                <div class="text item item_flex">
                  <div class="el-div-with">ps：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="information.information_ps"></el-progress>
                </div>
                <div class="text item item_flex">
                  <div class="el-div-with">rl：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="information.information_rl"></el-progress>
                </div>
                <div class="text item item_flex">
                  <div class="el-div-with">申请材料：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="information.information_ma"></el-progress>
                </div>
              </el-card>
            </template>
          </el-step>
          <el-step>
            <template slot="title">
              <span style="color: black">确认文书</span>
            </template>
            <template slot="description">
              <el-card class="box-card">
                <div class="text item item_flex">
                  <div class="el-div-with">cv：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="document.cv"></el-progress>
                </div>
                <div class="text item item_flex">
                  <div class="el-div-with">ps：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="document.ps"></el-progress>
                </div>
                <div class="text item item_flex">
                  <div class="el-div-with">rl：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="document.rl"></el-progress>
                </div>
              </el-card>
            </template>
          </el-step>
          <el-step>
            <template slot="title">
              <span style="color: black">递交</span>
            </template>
            <template slot="description">
              <el-card class="box-card">
                <div class="text item item_flex" v-for="item in apply_direction_data">
                  <div class="el-div-with">{{item.name}}：</div>
                  <el-progress class="el-progress-with" :text-inside="true" :stroke-width="15" :percentage="item.sub_confirmation"></el-progress>
                </div>
                <div class="text item item_flex" v-if="apply_direction_data.length==0" style="color: red">
                  <div class="el-div-with">暂无数据</div>
                </div>
              </el-card>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import { get_user_base_statistics } from '@/api/mycenter_studyabroad'
import {user_bind_info} from "../../../api/mycenter_studyabroad";
export default {
  name: 'TabFifteen',
  data() {
    return {
      chart: null,
      document: [],
      information: [],
      user_profiles: [],
      apply_direction_data: [],
      bindInfo: [],
      lessonOpenInfo: []
    }
  },
  mounted() {
    this.getStudyAbroadInformationStatistics()
    this.getUserBindInfo()
  },
  created() {},
  methods: {
    getUserBindInfo() {
      this.$store
        .dispatch(
          "userAbroad/geUserAbroadData",
          parseInt(this.$route.query.userId)
        )
        .then(() => {
          this.bindInfo = this.$store.state.userAbroad.userAbroadData;
          this.lessonOpenInfo = this.$store.state.userAbroad.lessonOpenInfo;
        })
    },
    getStudyAbroadInformationStatistics() {
      get_user_base_statistics({
      }).then((response) => {
        const option_x = {
          radar: {
            radius: '50%',
            indicator: [
              { name: '实习工作经历', max: 3 },
              { name: '学术项目', max: 3 },
              { name: '荣誉奖励', max: 3 },
              { name: '课外活动', max: 3 },
              { name: '语言', max: 3 }
            ]
          },
          series: [
            {
              name: 'Budget vs spending',
              type: 'radar',
              data: [
                {
                  value: [2, 0, 4, 2, 0],
                  name: 'Actual Spending'
                }
              ]
            }
          ]
        }
        option_x.radar.indicator = response.data.title
        option_x.series[0].data[0].value = response.data.content
        this.chart = echarts.init(this.$refs.echartsRef)
        this.chart.setOption(option_x)
        this.user_profiles = response.data.user_profiles
        this.apply_direction_data = response.data.apply_direction_data
        this.information = response.data.information
        this.document = response.data.document
      })
    },
  },


}
</script>
<style>
.el-step__description{
  padding-right:0 !important
}
/*.el-card__body, .el-main{*/
/*  padding: 20px 10px 20px 0;*/
/*}*/
</style>
<style lang="scss" scoped>
.item_flex{
  display:flex;
  flex-direction:row;
  align-items:center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
}
.el-step__description{
  padding-right:0
}
.item_flex .el-div-with{
  text-align: right;
  font-size: 0.8rem;
  width: 30%
}
.item_flex .el-progress-with{
  width: 70%
}
.color_blue{
  color: #02ABFAFF;
}
.bg_content{
  font-size: 0.7rem;
  width: 50%;
  float: left;
  padding-left: 1rem;
}
.border-bottom-color{
  border-bottom: 1px solid #E8E6E5FF;
}
.padding-bottom{
  padding-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_sixteen.vue